export const clamp = (min, value, max) =>
  Math.min(max, Math.max(value, min));

export const isNumeric = value => !isNaN(parseFloat(value)) && isFinite(value);
export const number = (value, defaultValue) => isNumeric(value) ? +value : +defaultValue;
